import {
  GET_JOB_SEEKER_PLANS,
  GET_MY_JOB_SEEKER_SUBSCRIPTION,
  JOB_SEEKER_SUBSCRIBE,
  JOB_SEEKER_CANCEL,
  GET_JOB_SEEKER_USAGE,
  CHECK_FEATURE_ACCESS,
  USE_CREDIT,
  GET_USER_TIER,
  TOGGLE_JOB_SEEKER_AUTO_RENEW,
  CANCEL_PRO_HUNTER_TRIAL,
  ERROR,
} from "../actionTypes";

const initialState = {
  plans: [],
  mySubscription: null,
  usage: null,
  featureAccess: {},
  userTier: null,
  subscribeResult: null,
  cancelResult: null,
  loading: false,
  error: null,
};

const jobSeekerSubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_JOB_SEEKER_PLANS:
      return {
        ...state,
        plans: action.payload,
        error: null,
      };

    case GET_MY_JOB_SEEKER_SUBSCRIPTION:
      return {
        ...state,
        mySubscription: action.payload,
        error: null,
      };

    case JOB_SEEKER_SUBSCRIBE:
      return {
        ...state,
        subscribeResult: action.payload,
        mySubscription: action.payload?.subscription || state.mySubscription,
        error: null,
      };

    case JOB_SEEKER_CANCEL:
      return {
        ...state,
        cancelResult: action.payload,
        mySubscription: state.mySubscription
          ? {
              ...state.mySubscription,
              auto_renew: 0,
              cancel_at_period_end: 1,
            }
          : state.mySubscription,
        error: null,
      };

    case TOGGLE_JOB_SEEKER_AUTO_RENEW: {
      const isAutoRenew = Boolean(
        action.payload?.auto_renew ?? action.payload?.data?.auto_renew
      );
      return {
        ...state,
        mySubscription: state.mySubscription
          ? {
              ...state.mySubscription,
              auto_renew: isAutoRenew ? 1 : 0,
              cancel_at_period_end: isAutoRenew ? 0 : 1,
              is_trial_cancelled: state.mySubscription?.is_trial
                ? !isAutoRenew
                : state.mySubscription?.is_trial_cancelled,
              trial_status: state.mySubscription?.is_trial
                ? isAutoRenew
                  ? "active"
                  : "cancelled"
                : state.mySubscription?.trial_status,
            }
          : state.mySubscription,
        error: null,
      };
    }

    case CANCEL_PRO_HUNTER_TRIAL:
      return {
        ...state,
        mySubscription: state.mySubscription
          ? {
              ...state.mySubscription,
              is_trial_cancelled: true,
              trial_status: "cancelled",
              auto_renew: 0,
              cancel_at_period_end: 1,
            }
          : state.mySubscription,
        cancelResult: action.payload,
        error: null,
      };

    case GET_JOB_SEEKER_USAGE:
      return {
        ...state,
        usage: action.payload,
        error: null,
      };

    case CHECK_FEATURE_ACCESS:
      return {
        ...state,
        featureAccess: {
          ...state.featureAccess,
          [action.payload.feature]: action.payload,
        },
        error: null,
      };

    case USE_CREDIT:
      return {
        ...state,
        mySubscription: {
          ...state.mySubscription,
          credits_remaining: action.payload?.credits_remaining ?? state.mySubscription?.credits_remaining,
        },
        error: null,
      };

    case GET_USER_TIER:
      return {
        ...state,
        userTier: action.payload,
        error: null,
      };

    case ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default jobSeekerSubscriptionReducer;
